// src/data/team.ts
export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  experience: string;
  specialties: string[];
  certification: string;
}

export const team: TeamMember[] = [
  {
    id: '1',
    name: 'Sandra Adjoa Appiah',
    role: 'Founder & Master Nail Technician',
    bio: 'With over 5 years of experience in nail artistry, AJ combines traditional Ghanaian beauty practices with modern techniques. Trained in London and Accra, she brings international standards to local nail care.',
    experience: '5+ years',
    specialties: ['Adinkra Nail Art', 'Gel Enhancements', 'Bridal Nails', 'Corporate Packages'],
    certification: 'Certified Master Nail Technician (International Nail Association)'
  },
  {
    id: '2',
    name: 'Kelvin',
    role: 'Senior Nail Technician',
    bio: 'Specializing in therapeutic pedicures using traditional Ghanaian ingredients. Kelvin has a background in skincare and focuses on holistic nail health.',
    experience: '5 years',
    specialties: ['Therapeutic Pedicures', 'Natural Nail Care', 'Men\'s Grooming'],
    certification: 'Advanced Pedicure Specialist'
  },
  {
    id: '3',
    name: 'Big Dee',
    role: 'Nail Art Specialist',
    bio: 'A fine arts graduate who specializes in custom nail designs. Big Dee creates everything from intricate Adinkra symbols to modern abstract patterns.',
    experience: '4 years',
    specialties: ['Hand-painted Designs', '3D Nail Art', 'Airbrush Techniques'],
    certification: 'Nail Art Certification (London Academy)'
  }
];